import { useState } from 'react';

import { Btn } from '../../components/Btn';
import { Modal } from '../../components/Modal';
import { type AppErrorItem, toSupportText } from './errorSupport';

export function ErrorPopup({
  item,
  onClose,
}: {
  item: AppErrorItem | null;
  onClose: () => void;
}) {
  const [copyState, setCopyState] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(toSupportText(item!));
      setCopyState('คัดลอกแล้ว');
    } catch {
      setCopyState('คัดลอกไม่สำเร็จ');
    }
  };
  return (
    <Modal open={!!item} title="เกิดข้อผิดพลาดจากระบบ" onClose={onClose}>
      {item && (
        <div className="space-y-5" aria-describedby="system-error-message">
          <div className="rounded-card border border-danger/20 bg-danger-light/30 p-4">
            <p id="system-error-message" className="font-bold text-danger">
              {item.message}
            </p>
          </div>
          <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
            <dt className="text-ink-3">Error code</dt>
            <dd className="font-mono break-all">{item.code}</dd>
            <dt className="text-ink-3">HTTP status</dt>
            <dd>{item.status || 'network'}</dd>
            <dt className="text-ink-3">Request ID</dt>
            <dd className="font-mono break-all">{item.requestId ?? 'ไม่มี'}</dd>
            <dt className="text-ink-3">Endpoint</dt>
            <dd className="font-mono break-all">{item.endpoint}</dd>
            <dt className="text-ink-3">หน้า</dt>
            <dd>{item.pathname}</dd>
            <dt className="text-ink-3">เวลา</dt>
            <dd>{new Date(item.lastOccurredAt).toLocaleString('th-TH')}</dd>
          </dl>
          {item.occurrences > 1 && (
            <p className="text-sm font-semibold text-warn">
              เกิดซ้ำ {item.occurrences} ครั้ง
            </p>
          )}
          {copyState && <p className="text-sm text-ink-3">{copyState}</p>}
          <div className="flex flex-wrap justify-end gap-2">
            <Btn onClick={() => void copy()}>คัดลอกรายละเอียด</Btn>
            {item.retry && (
              <Btn kind="primary" onClick={() => void item.retry?.()}>
                ลองใหม่
              </Btn>
            )}
            <Btn kind="default" onClick={onClose}>
              ปิด
            </Btn>
          </div>
        </div>
      )}
    </Modal>
  );
}
